module.exports = __webpack_public_path__ + "img/hr-tree-07-f-trunk.07ff3e13.png";